import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FanspeedLocationModel } from './fanspeed-store/fanspeed.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-fanspeed-ui',
  templateUrl: './fanspeed.component.html',
  styleUrls: ['./fanspeed.component.scss'],
  imports: [FaIconComponent],
})
export class FanspeedComponent {
  readonly fanspeed = input.required<FanspeedLocationModel | undefined>();
}
